export default __webpack_public_path__ + "static/media/person_3.0d35ed3b.png";